import { ClearOutlined } from "@ant-design/icons";
import { Button } from "antd";
import Search from "antd/es/input/Search";
import Select from "antd/es/select";
import React from "react";
import { FindAllTeamMembersFilter } from "../../../Interface";

interface TeamMembersFilterMenuProps {
  filters: FindAllTeamMembersFilter;
  updateFilters: (key: keyof FindAllTeamMembersFilter, value: any | null) => void;
  onSearch: (search: string) => void;
  onClearAll: () => void;
}

const teamMembersFilterMenuOptions = [
  {
    label: "Active",
    value: true,
  },
  {
    label: "Inactive",
    value: false,
  },
];

const teamMembersSortMenuOptions = [
  {
    label: "Newest first",
    value: "recently.joined",
  },
  {
    label: "Oldest first",
    value: "oldest.joined",
  },
  {
    label: "Name A-Z",
    value: "name.a.z",
  },
  {
    label: "Name Z-A",
    value: "name.z.a",
  },
];

const teamMembersRoleMenuOptions = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Member",
    value: "member",
  },
];

const TeamMembersFilterMenu: React.FC<TeamMembersFilterMenuProps> = ({
  filters,
  updateFilters,
  onSearch,
  onClearAll,
}) => {
  const handleStatusChange = (value: boolean | null) => {
    updateFilters("isActive", value);
  };

  const handleRoleChange = (value: string | null) => {
    updateFilters("role", value);
  };

  const handleSortChange = (value: 'recently.joined' | 'oldest.joined' | 'name.a.z' | 'name.z.a' | null) => {
    updateFilters("sort", value);
  };

  const handleSearch = (value: string) => {
    onSearch(value);
  };

  return (
    <div className="team-members-filter-menu">
      <div className="team-members-filter-menu-search">
        <Search 
          placeholder="Search team members" 
          enterButton 
          onSearch={handleSearch}
          defaultValue={filters.search || ""}
        />
      </div>
      <div className="team-members-filter-menu-other-filters">
        <Select
          placeholder="Filter by status"
          options={teamMembersFilterMenuOptions}
          allowClear
          value={filters.isActive}
          onChange={handleStatusChange}
        />
        <Select
          placeholder="Filter by role"
          options={teamMembersRoleMenuOptions}
          allowClear
          value={filters.role}
          onChange={handleRoleChange}
        />
        <Select
          placeholder="Sort by"
          options={teamMembersSortMenuOptions}
          allowClear
          value={filters.sort}
          onChange={handleSortChange}
        />
        <Button 
          type="default" 
          size="middle" 
          icon={<ClearOutlined />}
          onClick={onClearAll}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default TeamMembersFilterMenu;
